import siteIdToMucd from '../utils/siteIdtoMucd';

function buildInput(params = {}) {
  const {
    first = 10,
    orderBy = 'DATE',
    after,
    departureCode,
    durationFrom,
    durationTo,
    dateFrom,
    dateTo,
    tripType,
    priceTo,
    destinationCode,
  } = params;

  return [
    `first:${first}`,
    `orderBy: ${orderBy}`,
    after && `after:"${after}"`,
    departureCode && `departureCode:[${departureCode.map((d) => `"${d}"`)}]`,
    durationFrom && `durationFrom:${durationFrom}`,
    durationTo && `durationTo:${durationTo}`,
    dateFrom && `dateFrom:"${dateFrom}"`,
    dateTo && `dateTo:"${dateTo}"`,
    tripType && `tripTypes:[${tripType}]`,
    priceTo && `priceTo:${priceTo}`,
    destinationCode && `destinationCode:[${destinationCode.map((d) => `"${d}"`)}]`,
  ]
    .filter((x) => x)
    .join(' ');
}

function tripsQuery(input) {
  const query = `
    lmsTrips(${input}) {
      messages {
        header
        message
        caCodes {
          id
          program
        }
      }
      metadata {
        nrOfSpecified
        nrOfFlightOnly
        nrOfUnspecified
        totalCount
        maxPrice
        minPrice
        hasDurations {
          miniweek
          oneweek
          twoweeks
          threeweeks
          longvacation
        }
        countries {
          countryCode
          name
          count
          destinations {
            code
            name
            count
          }
        }
        departures {
          code
          name
        }
        availableDates {
          value
          display
        }
      }
      edges {
        node {
          date {
            day
            monthShortName
            dayShortName
            short
            raw
          }
          duration
          destinationCode
          departureCode
          numFreeSeats
          serialNumber
          departure {
            caId
            name
          }
          destinationAirport
          offers {
            tripId
            priceFormatted
            price
            type
            hotelCode
          }
          hotel {
            content {
              geographical {
                country {
                  caId
                  url
                  name
                }
                resort {
                  caId
                }
                area {
                  caId
                }
              }
            }
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  `;
  return query;
}

function createQuery(siteId, body) {
  const mucd = siteIdToMucd(siteId);
  return {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      marketUnit: mucd,
      'x-caller-app': 'lastminutesales',
    },
    caller: 'lastminutesales',
    body: JSON.stringify(body),
  };
}

export function createGetTripsQuery(siteId, params = {}) {
  const input = buildInput(params);

  return createQuery(siteId, {
    query: `
      {
        ${tripsQuery(input)}
      }
    `,
  });
}

export function createInitialQuery(siteId, attributeCollection, limit, params = {}) {
  const input = buildInput({ ...params, first: limit || 10 });

  const query = createQuery(siteId, {
    query: `
      {
        attributeCollection: attributeCollectionsContentDeliveryApi(aliases: ["${attributeCollection}"])
        ${tripsQuery(input)}
      }
    `,
  })

  return query;
}
